const autoNgTemplateLoaderTemplate1 = require('./containerCapabilities.html');

angular.module('portainer.docker').component('containerCapabilities', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    capabilities: '=',
  },
});
